'use client';
import { useState } from 'react';

export const MXLockerLogoBadge = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="absolute left-[1rem] top-[0.8rem] z-20 overflow-hidden transition-all duration-300 ease-in-out"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`flex items-center gap-3 rounded-full border-2 transition-all duration-300 ease-in-out ${
          isHovered
            ? 'h-[4.5rem] w-auto border-transparent bg-[#C41719] px-3 shadow-md'
            : 'h-[4.5rem] w-auto border-transparent bg-transparent px-0 shadow-none'
        } box-border overflow-hidden`}
      >
        <span
          className={`whitespace-nowrap text-[1.5rem] font-semibold leading-none text-white transition-all duration-300 ease-in-out ${
            isHovered
              ? 'max-w-[35rem] translate-x-0 opacity-100'
              : 'max-w-0 -translate-x-2 opacity-0'
          } overflow-hidden`}
        >
          Fulfilled by
        </span>
        <div className="flex h-full items-center justify-center overflow-hidden">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-[4rem] w-[4rem]"
          >
            <circle cx="18" cy="18" r="18" fill="#C41719" />
            <g clipPath="url(#clip0_18624_138670)">
              <path
                d="M8.58629 9.5459L5.14307 21.7096H8.1081L11.4554 9.5459H8.58629Z"
                fill="white"
              />
              <path
                d="M16.2691 9.5459L12.9217 13.2492L11.7418 9.5459L10.4673 13.8877L11.4554 18.2295L15.0256 13.8877L16.2691 9.5459Z"
                fill="white"
              />
              <path
                d="M16.0137 21.7096L19.4328 9.5459H16.4563L13.0493 21.7096H16.0137Z"
                fill="white"
              />
              <path
                d="M22.5883 21.7134H25.9477L24.4236 15.2487L29.1153 9.5459H26.2944L23.7841 12.6507L23.0665 9.5459H19.7312L21.1544 15.6277L12.105 26.4539H14.9735L21.7875 18.3732L22.5883 21.7134Z"
                fill="white"
              />
              <path
                d="M19.2531 22.4082H18.7514L17.9741 25.2097H19.7916L19.8869 24.7906L18.5838 24.7785L19.2531 22.4082Z"
                fill="white"
              />
              <path
                d="M22.0826 22.4082H21.0228L20.4487 22.8394L19.9229 24.7747L20.2734 25.2338H21.2933L21.9029 24.7511L22.4287 22.8553L22.0826 22.4082ZM21.4609 24.5508L21.2336 24.746H20.596L20.4563 24.5743L20.8824 23.0416L21.1098 22.8699H21.7194L21.8788 23.0416L21.4609 24.5508Z"
                fill="white"
              />
              <path
                d="M23.6844 24.1641L23.5809 24.5909L23.3618 24.7467H22.7801L22.6487 24.5387L23.0589 23.0785L23.306 22.8712H23.9016L23.9994 23.0703L23.9232 23.4054H24.4255L24.5653 22.8152L24.2344 22.4082H23.238L22.6087 22.8871L22.0867 24.7225L22.469 25.2332H23.4457L24.035 24.7626L24.1823 24.1718L23.6844 24.1641Z"
                fill="white"
              />
              <path
                d="M26.9004 22.4082H26.3625L25.0911 23.5371L25.394 22.4082H24.8841L24.0947 25.2332H24.625L24.9 24.2557L25.3737 23.8366L25.6449 25.2332H26.1434L25.7808 23.4378L26.9004 22.4082Z"
                fill="white"
              />
              <path
                d="M27.1594 23.9485H28.0954L28.1869 23.565H27.2508L27.4299 22.875H28.7889L28.9121 22.4082H27.099L26.2944 25.2332H28.1272L28.2548 24.7626H26.932L27.1594 23.9485Z"
                fill="white"
              />
              <path
                d="M30.658 23.5937L30.8574 22.7993L30.5628 22.4082H29.1161L28.3115 25.2338H28.8088L29.1314 24.0446H29.4698L29.661 25.2338H30.1671L29.9601 24.0446H30.0998L30.658 23.5937ZM29.259 23.614L29.454 22.8795H30.1913L30.303 23.0111L30.2116 23.4461L30.0084 23.6337L29.259 23.614Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_18624_138670">
                <rect
                  width="25.7143"
                  height="16.908"
                  fill="white"
                  transform="translate(5.14307 9.5459)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};
